





































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import LogoSelector from '@ui/LogoSelector'
import CSVImporter from '@ui/POI/CSVImporter'
import AddCustomPOITrigger from './AddCustomPOITrigger.coffee'

settings =
  name: 'AddCustomPOITriggerModal'

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton, LogoSelector, CSVImporter }
    mixins: [AddCustomPOITrigger.trigger()]

    data: ->
      csvTemplateLinks: [
        '1VZDCmEJ_1awAxjA6MM1C6qi1FzmDI0s5AryxR-r3kg0/edit#gid=0',
        '1VZDCmEJ_1awAxjA6MM1C6qi1FzmDI0s5AryxR-r3kg0/edit#gid=1903192301',
      ]

    computed:
      canSubmit: -> @modal.data?.domain?.length

    methods:
      modalData: ->
        {
          name: '',
          name_postfix: ''
          domain: '',
          logo: '',
          csv_string: '',
          google_sheet_url: ''
        }

      hiSelectLogo: (brand) ->
        @modal.data.logo = brand.logo
        @modal.data.domain = brand.domain
        @modal.data.name = brand.name

    watch:
      'modal.show': (value) ->
        @$refs.logoSelector.cleanup() if value

export default VueOptions.vue settings
